import { getPath } from '@/router/common'

const baseUrl = {
  title: '流程页',
  path: 'flowChart'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'flowChart_Index',
    component: () =>
      import(
        /* webpackChunkName: "flowChart_Index" */ '@/views/flowChart/index/index.vue'
      ),
    meta: {
      title: '流程页'
    }
  }
]
